import React from 'react'
import ReactDOM from 'react-dom'
import HeaderApp from '../applications/components/HeaderApp'
import ProductsApp from '../applications/components/ProductsApp'
import {
    componentExistsOnPage,
    getComponentProps,
    getRootElement,
} from '../applications/utils/ssr'

if (componentExistsOnPage('HeaderApp')) {
    const props = getComponentProps('HeaderApp')

    ReactDOM.hydrate(<HeaderApp {...props} />, getRootElement('HeaderApp'))
}

const props = getComponentProps('ProductsApp')

ReactDOM.hydrate(<ProductsApp {...props} />, getRootElement('ProductsApp'))
